import {createEntityAdapter} from '@reduxjs/toolkit';

export const teamMembersAdapter = createEntityAdapter({
	selectId: (teamMember) => teamMember.id,
});